// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .mobility-gridwall {
  min-height: 37.5rem;
  margin:0px !important;
} */

/* .mobility-gridwall .content .header{ 
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
} */


/* .mobility-gridwall .content .remove-gutter{ 
  padding:0;
} */


/* .mobility-gridwall .content .side-padding {
  padding-left: 1rem;
  padding-right: 1rem;
} */


/* .mobility-gridwall .content .gridwall-header {
  display: flex;
  flex-wrap: wrap;
  max-width: 1272px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 1rem;
} */


/* .mobility-gridwall .content .call-btn-container {
  position: fixed;
  right: 0;
  top: 390px;
  z-index: 9999;
}
.mobility-gridwall .content .call-btn-container .call-btn {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  background-color: #000000;
  border: 2px solid #FFF;
  color: #FFF;
  border-radius: 10px;
  height: 70px;
  width: 25px;
  padding: 5px;
} */
/* .mobility-gridwall .content .call-btn-container .call-btn span{
  margin-bottom: 5px;
  transform: rotate(270deg);
} */

/* .mobility-gridwall .content .top-pad {
  padding-top: 1rem;
} */

/* .mobility-gridwall .content .bottom-pad {
  padding-bottom: 1rem;
} */

/* .mobility-gridwall .content .full-width {
  width: 100%;
}
.mobility-gridwall .content .left-flex {
  width: 66%;
}
.mobility-gridwall .content .right-flex {
  width: 30%;
  margin-left: auto;
} */

/* .content .gridwall-header .chat-link, .content .gridwall-header .contact-sales {
  margin-top: 1rem;
  margin-right: 1.5rem;
} */


/* .content .gridwall-header .search-input {
  margin-top: 1rem;
  max-width: 66%;
} */

.heading {
  font-size: 16px!important;
  font-family: sans-serif;
}


/* .mobility-gridwall .ezYXtw {
  padding-bottom: 0;
} */

/* .mobility-gridwall .notification :nth-child(1) {
  opacity: 1 !important;
} */

/* .mobility-gridwall .promo-banner-large {
  width: 100%;
} */

/* .mobileFiltersCloseBtnWrap {margin-top:30px;}
.mobileFiltersCloseBtnWrap > div > div {display: flex; gap:10px;}
.mobileFiltersCloseBtnWrap button {width:90%;} */

/* .mobility-gridwall .close-clear-wrap {width: 100%; display: block; padding-top:20px;}
.mobility-gridwall .close-clear-wrap .close-clear-wrap {border-top:none; padding-top:0px;}
.mobility-gridwall .close-clear-wrap > div > div {max-width:100%; flex-basis: auto; display:flex;}
.mobility-gridwall .close-clear-wrap button {width:95%;}
.mobility-gridwall .close-clear-wrap button span {display:flex; align-items:center; padding:0.5rem 0.7rem; } */


/* 
.mobility-gridwall .filter-sort-wrap .filter-box-wrap {width:65%; display:flex; align-items:center;}
.mobility-gridwall .filter-sort-wrap .sortbywrapper {width:35%; order:2;}
.mobility-gridwall .filter-sort-wrap {justify-content:space-between;} */

/*
.mobility-gridwall .filter-box-wrap > div {height:fit-content; flex-wrap: wrap; gap:0.5rem;}
.mobility-gridwall .filter-box-wrap > div > div { border-radius: 5px; display: flex; align-items: center; height: auto; padding:3px 4px 3px 8px; gap: 0px;}  */



/* .mobility-gridwall .filter-box-wrap .filter-clear-wrap {margin-left:0.5rem;}
.mobility-gridwall .filter-box-wrap .filter-clear-wrap > button {border:none; font-size:0.75rem; text-decoration: underline; font-weight: 400; line-height: 1rem; color: #000000;}
.mobility-gridwall .filter-box-wrap .filter-clear-wrap > button:hover {border:none !important; box-shadow:none !important;}
.mobility-gridwall .filter-box-wrap .filter-clear-wrap > button span {padding:0px !important;}
 */


.mob-filter-sort-wrap {display: flex; gap: 10px;}
.compare-devices{ position:fixed; bottom:0px; left:0px; z-index: 99; background: white; width:100%}
/* .compare-devices h5{margin-left: 9rem;} */


@media (max-width:800px) {
  .compare-devices h5{margin-left: 1rem;}
  /* .mobility-gridwall .filter-sort-wrap .filter-box-wrap {width:50%;} */

}


@media (max-width: 545px) {
  /* .mobility-gridwall .gridwall-header .search-input {max-width: 100%; } */
  /* .mobility-gridwall .filter-sort-wrap .filter-box-wrap {width:100%; order:2;} */
  /* .mobility-gridwall .filter-sort-wrap .sortbywrapper {width:100%; order:1; margin-bottom:1rem; padding-bottom:1rem; border-bottom:1px solid #000;} */
  /* .sortByDropdown > p {text-align: left;} */
}

.ulist-type li{
  list-style: none;
}
.ulist-type{
  padding-left: 20px !important;
}

.ulist-type > li::before {
  content: "- ";
}

.buss-gridwall-header{
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-left: 2rem !important;
}
@media screen and (max-width:767px) {
  .desktop-vw , .dsk-tp-vw-rslt{
  display: none !important;
    }
    .mb-vw{
      display: block;
      padding: 1.5rem 1rem 0rem 1rem ;
    }
  .mb-vw-fltr{
    display: flex !important;
    justify-content: space-between;
    width: 100%;
  }
  .buss-search{
    width: 100%;
  }
}

@media screen and (min-width:768px) {
  .desktop-vw, .dsk-tp-vw-rslt{
display: block !important;
  }
  .mb-vw{
    display: none;
  }
  .mb-vw-fltr{
    display: none !important;
  }
  .mb-vw-fltr > div {
    padding:3px 2px 3px 0px;
  }
}

.grdwl-ftr{
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.lt-ctn{
width: 49%;
padding-right: 1%;
}
.rt-ctn{
width: 49%;
padding-left: 1%;
}
.ftr-lnk{
  padding: 0 1.5rem;
}
@media screen and (max-width:767px) {
  .grdwl-ftr{
    display: inline;
  }
  .lt-ctn, .rt-ctn{
    width: 98% !important;
  }
  .mb-vw-pd{
    padding: 0 12px;
  }
  .ftr-lnk{
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Marketplace/components/MobilityGridwall/MobilityGridwall.css"],"names":[],"mappings":"AAAA;;;GAGG;;AAEH;;;;;GAKG;;;AAGH;;GAEG;;;AAGH;;;GAGG;;;AAGH;;;;;;;;;GASG;;;AAGH;;;;;;;;;;;;;;;;;;GAkBG;AACH;;;GAGG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;;;;;;;;GASG;;AAEH;;;GAGG;;;AAGH;;;GAGG;;AAEH;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;;AAGA;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;gDAEgD;;AAEhD;;;;8GAI8G;;;AAG9G;;;uEAGuE;;AAEvE;;8JAE8J;;;;AAI9J;;;;EAIE;;;AAGF,uBAAuB,aAAa,EAAE,SAAS,CAAC;AAChD,kBAAkB,cAAc,EAAE,UAAU,EAAE,QAAQ,EAAE,WAAW,EAAE,iBAAiB,EAAE,UAAU;AAClG,4CAA4C;;;AAG5C;EACE,oBAAoB,iBAAiB,CAAC;EACtC,uEAAuE;;AAEzE;;;AAGA;EACE,0EAA0E;EAC1E,iFAAiF;EACjF,sJAAsJ;EACtJ,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE;EACA,wBAAwB;IACtB;IACA;MACE,cAAc;MACd,+BAA+B;IACjC;EACF;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;AACF,yBAAyB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;AACA;AACA,UAAU;AACV,iBAAiB;AACjB;AACA;AACA,UAAU;AACV,gBAAgB;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["/* .mobility-gridwall {\n  min-height: 37.5rem;\n  margin:0px !important;\n} */\n\n/* .mobility-gridwall .content .header{ \n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-bottom: 2rem;\n} */\n\n\n/* .mobility-gridwall .content .remove-gutter{ \n  padding:0;\n} */\n\n\n/* .mobility-gridwall .content .side-padding {\n  padding-left: 1rem;\n  padding-right: 1rem;\n} */\n\n\n/* .mobility-gridwall .content .gridwall-header {\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 1272px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  padding-bottom: 1rem;\n} */\n\n\n/* .mobility-gridwall .content .call-btn-container {\n  position: fixed;\n  right: 0;\n  top: 390px;\n  z-index: 9999;\n}\n.mobility-gridwall .content .call-btn-container .call-btn {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  flex-direction: column;\n  background-color: #000000;\n  border: 2px solid #FFF;\n  color: #FFF;\n  border-radius: 10px;\n  height: 70px;\n  width: 25px;\n  padding: 5px;\n} */\n/* .mobility-gridwall .content .call-btn-container .call-btn span{\n  margin-bottom: 5px;\n  transform: rotate(270deg);\n} */\n\n/* .mobility-gridwall .content .top-pad {\n  padding-top: 1rem;\n} */\n\n/* .mobility-gridwall .content .bottom-pad {\n  padding-bottom: 1rem;\n} */\n\n/* .mobility-gridwall .content .full-width {\n  width: 100%;\n}\n.mobility-gridwall .content .left-flex {\n  width: 66%;\n}\n.mobility-gridwall .content .right-flex {\n  width: 30%;\n  margin-left: auto;\n} */\n\n/* .content .gridwall-header .chat-link, .content .gridwall-header .contact-sales {\n  margin-top: 1rem;\n  margin-right: 1.5rem;\n} */\n\n\n/* .content .gridwall-header .search-input {\n  margin-top: 1rem;\n  max-width: 66%;\n} */\n\n.heading {\n  font-size: 16px!important;\n  font-family: sans-serif;\n}\n\n\n/* .mobility-gridwall .ezYXtw {\n  padding-bottom: 0;\n} */\n\n/* .mobility-gridwall .notification :nth-child(1) {\n  opacity: 1 !important;\n} */\n\n/* .mobility-gridwall .promo-banner-large {\n  width: 100%;\n} */\n\n/* .mobileFiltersCloseBtnWrap {margin-top:30px;}\n.mobileFiltersCloseBtnWrap > div > div {display: flex; gap:10px;}\n.mobileFiltersCloseBtnWrap button {width:90%;} */\n\n/* .mobility-gridwall .close-clear-wrap {width: 100%; display: block; padding-top:20px;}\n.mobility-gridwall .close-clear-wrap .close-clear-wrap {border-top:none; padding-top:0px;}\n.mobility-gridwall .close-clear-wrap > div > div {max-width:100%; flex-basis: auto; display:flex;}\n.mobility-gridwall .close-clear-wrap button {width:95%;}\n.mobility-gridwall .close-clear-wrap button span {display:flex; align-items:center; padding:0.5rem 0.7rem; } */\n\n\n/* \n.mobility-gridwall .filter-sort-wrap .filter-box-wrap {width:65%; display:flex; align-items:center;}\n.mobility-gridwall .filter-sort-wrap .sortbywrapper {width:35%; order:2;}\n.mobility-gridwall .filter-sort-wrap {justify-content:space-between;} */\n\n/*\n.mobility-gridwall .filter-box-wrap > div {height:fit-content; flex-wrap: wrap; gap:0.5rem;}\n.mobility-gridwall .filter-box-wrap > div > div { border-radius: 5px; display: flex; align-items: center; height: auto; padding:3px 4px 3px 8px; gap: 0px;}  */\n\n\n\n/* .mobility-gridwall .filter-box-wrap .filter-clear-wrap {margin-left:0.5rem;}\n.mobility-gridwall .filter-box-wrap .filter-clear-wrap > button {border:none; font-size:0.75rem; text-decoration: underline; font-weight: 400; line-height: 1rem; color: #000000;}\n.mobility-gridwall .filter-box-wrap .filter-clear-wrap > button:hover {border:none !important; box-shadow:none !important;}\n.mobility-gridwall .filter-box-wrap .filter-clear-wrap > button span {padding:0px !important;}\n */\n\n\n.mob-filter-sort-wrap {display: flex; gap: 10px;}\n.compare-devices{ position:fixed; bottom:0px; left:0px; z-index: 99; background: white; width:100%}\n/* .compare-devices h5{margin-left: 9rem;} */\n\n\n@media (max-width:800px) {\n  .compare-devices h5{margin-left: 1rem;}\n  /* .mobility-gridwall .filter-sort-wrap .filter-box-wrap {width:50%;} */\n\n}\n\n\n@media (max-width: 545px) {\n  /* .mobility-gridwall .gridwall-header .search-input {max-width: 100%; } */\n  /* .mobility-gridwall .filter-sort-wrap .filter-box-wrap {width:100%; order:2;} */\n  /* .mobility-gridwall .filter-sort-wrap .sortbywrapper {width:100%; order:1; margin-bottom:1rem; padding-bottom:1rem; border-bottom:1px solid #000;} */\n  /* .sortByDropdown > p {text-align: left;} */\n}\n\n.ulist-type li{\n  list-style: none;\n}\n.ulist-type{\n  padding-left: 20px !important;\n}\n\n.ulist-type > li::before {\n  content: \"- \";\n}\n\n.buss-gridwall-header{\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  padding-left: 2rem !important;\n}\n@media screen and (max-width:767px) {\n  .desktop-vw , .dsk-tp-vw-rslt{\n  display: none !important;\n    }\n    .mb-vw{\n      display: block;\n      padding: 1.5rem 1rem 0rem 1rem ;\n    }\n  .mb-vw-fltr{\n    display: flex !important;\n    justify-content: space-between;\n    width: 100%;\n  }\n  .buss-search{\n    width: 100%;\n  }\n}\n\n@media screen and (min-width:768px) {\n  .desktop-vw, .dsk-tp-vw-rslt{\ndisplay: block !important;\n  }\n  .mb-vw{\n    display: none;\n  }\n  .mb-vw-fltr{\n    display: none !important;\n  }\n  .mb-vw-fltr > div {\n    padding:3px 2px 3px 0px;\n  }\n}\n\n.grdwl-ftr{\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n.lt-ctn{\nwidth: 49%;\npadding-right: 1%;\n}\n.rt-ctn{\nwidth: 49%;\npadding-left: 1%;\n}\n.ftr-lnk{\n  padding: 0 1.5rem;\n}\n@media screen and (max-width:767px) {\n  .grdwl-ftr{\n    display: inline;\n  }\n  .lt-ctn, .rt-ctn{\n    width: 98% !important;\n  }\n  .mb-vw-pd{\n    padding: 0 12px;\n  }\n  .ftr-lnk{\n    padding: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
